module.exports = __webpack_public_path__ + "img/lg_ring_g_s_null_1@2x.fcb4bbb7.png";